<ng-container>
  <div *ngIf="loading$ | async" class="loader">
   <div class="loader-bg">
    <svg>
        <symbol id="s-text">
          <text x="50%" y="50%" text-anchor="middle">iDEC</text>
        </symbol>
        <g class="g-ants">
          <use xlink:href="#s-text" class="text-copy"></use>
          <use xlink:href="#s-text" class="text-copy"></use>
          <use xlink:href="#s-text" class="text-copy"></use>
          <use xlink:href="#s-text" class="text-copy"></use>
          <use xlink:href="#s-text" class="text-copy"></use>
        </g>	
      </svg>
    </div>
</div>
  </ng-container>
<div class="main-container" id="containerCanvas">
  <div #canvas id="canvas" id="three-container"></div>
</div>
  